import Modal from './Modal';
export { ModalWidths, maxModalWidths } from './Modal';
export default Modal;
